<button type="button" mat-dialog-close class="close-button">
  <em class="icon-salir"></em>
</button>
<h2 mat-dialog-title>¿Qué es una PEP - Persona Expuesta Públicamente?</h2>
<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <p class="additional-info">
      Tú, o alguno de tus relacionados<span class="asterisks">*</span> es:
    </p>

    <ul class="list">
      <li>
        <span>
          Una persona expuesta políticamente, por ocupar actualmente o haber
          ocupado en un periodo de 2 años atrás algún cargo público relacionado
          en el Decreto 1674 de 2016<span class="asterisks">**</span>
        </span>
      </li>
      <li>
        <span>
          Un representante legal de alguna organización internacional y/o que
          desempeña funciones públicas destacadas en otro país<span
            class="asterisks"
            >***</span
          >.
        </span>
      </li>
      <li class="sub-list">
        <span>
          <span class="asterisks">*</span>Cónyuge, compañero(a), hijo(s),
          padres, nieto(s), hermano(s), abuelos, suegro(s), nuera(s), yerno(s).
        </span>
      </li>
      <li class="sub-list">
        <span>
          <span class="asterisks">**</span>Funcionarios públicos de la rama
          ejecutiva, legislativa y judicial con capacidad decisoria;
          representantes legales, presidentes, directores, tesoreros de partidos
          y movimientos políticos u otra forma de asociación política reconocida
          por la ley: directores y tesoreros de patrimonios autónomos o
          fideicomisos que administren recursos públicos.
        </span>
      </li>
      <li class="sub-list">
        <span>
          <span class="asterisks">***</span>Se entiende por PEP extranjeros: (i)
          jefes de Estado, jefes de Gobierno, ministros, subsecretarios o
          secretarios de Estado; (ii) congresistas o parlamentarios; (iii)
          miembros de tribunales supremos, tribunales constitucionales u otras
          altas instancias judiciales cuyas decisiones no admitan normalmente
          recurso, salvo en circunstancias excepcionales; (iv) miembros de
          tribunales o de las juntas directivas de bancos centrales; (v)
          embajadores, encargados de negocios y altos funcionarios de las
          fuerzas armadas, y (vi) miembros de los órganos administrativos, de
          gestión o de supervisión de empresas de propiedad estatal.
        </span>
      </li>
    </ul>
  </div>
  <div class="opacity-box"></div>
</div>
<div mat-dialog-actions class="mat-dialog-actions">
  <button mat-dialog-close class="btn btn-degraded blue" type="button">
    Entendido
  </button>
</div>
